export function injectAdTagAfterHeadings(
  markdown: string,
  {
    skipFirstHeading = true,
    minWordsBetweenAds = 150,
    headingInterval,
  }: {
    skipFirstHeading?: boolean;
    minWordsBetweenAds?: number;
    headingInterval?: number;
  } = {},
) {
  const headingRegex = /^###?\s+.*$/gm;
  const fallbackInterval = headingInterval && headingInterval > 0 ? headingInterval : null;
  const minimumWords = minWordsBetweenAds > 0 ? minWordsBetweenAds : 0;
  let result = '';
  let lastIndex = 0;
  let headingCount = 0;
  let headingsSinceLastAd = 0;
  let wordsSinceLastAd = Number.POSITIVE_INFINITY;
  let match: RegExpExecArray | null;

  while ((match = headingRegex.exec(markdown)) !== null) {
    const heading = match[0];
    const matchOffset = match.index;
    const beforeHeading = markdown.slice(lastIndex, matchOffset);

    result += beforeHeading;
    wordsSinceLastAd += countWords(beforeHeading);
    headingCount += 1;
    headingsSinceLastAd += 1;

    if (skipFirstHeading && headingCount === 1) {
      result += heading;
      lastIndex = headingRegex.lastIndex;
      continue;
    }

    const hasAdAlready = /<x-ad\s*\/>\s*$/.test(result);

    if (hasAdAlready) {
      result += heading;
      lastIndex = headingRegex.lastIndex;
      continue;
    }

    const canInsertFromWordThreshold = wordsSinceLastAd >= minimumWords;
    const canInsertFromHeadingFallback =
      fallbackInterval !== null && headingsSinceLastAd % fallbackInterval === 0;

    if (!canInsertFromWordThreshold && !canInsertFromHeadingFallback) {
      result += heading;
      lastIndex = headingRegex.lastIndex;
      continue;
    }

    // Keep ads in their own Markdown block, including after tightly spaced FAQ answers.
    result = `${result.trimEnd()}\n\n<x-ad />\n\n${heading}`;
    wordsSinceLastAd = 0;
    headingsSinceLastAd = 0;
    lastIndex = headingRegex.lastIndex;
  }

  result += markdown.slice(lastIndex);
  return result;
}

function countWords(text: string) {
  const plainText = text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]*`/g, ' ')
    .replace(/!\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/[#>*_\-]+/g, ' ');
  const normalizedText = plainText.replace(/[^0-9A-Za-zÀ-ÖØ-öø-ÿĀ-ž'’-]+/g, ' ').trim();

  if (!normalizedText) {
    return 0;
  }

  return normalizedText.split(/\s+/).length;
}
